import moment from "moment";
export const sanitizeText = (value) => {
  return typeof value === "string" ? value.trim() : value;
};

export const sanitizeDate = (value) => {
  if (value instanceof Date && !isNaN(value.getTime())) {
    return moment(value).format("YYYYMMDD");
  }
  if (typeof value === "string") {
    const m = moment(value, ["YYYY-MM-DD", "YYYYMMDD", moment.ISO_8601], true);
    return m.isValid() ? m.format("YYYYMMDD") : "";
  }
  return "";
};

export const sanitizeSelectValue = (value, options = []) => {
  return options.includes(value) ? value : "";
};

export const sanitizeValueByType = (value, type, extra = {}) => {
  switch (type) {
    case "text":
      return sanitizeText(value);
    case "date":
      return sanitizeDate(value);
    case "select":
      return sanitizeSelectValue(value, extra.options || []);
    default:
      return value;
  }
};
